<template>
  <div>
    <h4 class="text-center purple">{{$t('marketingCampaigns.sendNotificationTo')}}</h4>
    <div class="row">
      <div class="col-md-10 pad-bt-15">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <form>
          <div class="row">
            <div class="col-md-2 col-sm-6 col-xs-12 form-group">
              <label class="control-label text-purple">{{$t('marketingCampaigns.gender')}}</label>
              <select v-model="filters[1].value"
                      :placeholder="$t('marketingCampaigns.gender')"
                      class="form-control">
                <option selected=""  value=""> - {{$t('general.all')}} - </option>
                <option value="M">{{$t('gender.male')}}</option>
                <option value="F">{{$t('gender.female')}}</option>
              </select>
            </div>
            <div class="col-md-2 col-sm-6 col-xs-12 form-group">
              <label class="control-label text-purple">{{$t('marketingCampaigns.age')}}</label>
              <br>
              <select
                      name="age"
                      :placeholder="$t('marketingCampaigns.age')"
                      class="form-control"
                      v-model="filters[3].value">
                <option selected=""  value=""> - {{$t('general.all')}} - </option>
                <option value="20">{{$t('reportsAgesGroups.20')}}</option>
                <option value="20-30">{{$t('reportsAgesGroups["20-30"]')}}</option>
                <option value="30-40">{{$t('reportsAgesGroups["30-40"]')}}</option>
                <option value="40-50">{{$t('reportsAgesGroups["40-50"]')}}</option>
                <option value="50+">{{$t('reportsAgesGroups["50"]')}}</option>
              </select>
            </div>
            <div class="col-md-4 col-sm-6 col-xs-12 form-group">
              <label class="control-label text-purple">{{$t('marketingCampaigns.locations')}}</label>
              <v-select v-model="filters[4].value"
                          multiple
                          :options="locations"
                          value="token"
                          label="name">
                </v-select>
              <small class="text-danger" v-if="errors.has('location')">
                {{ getError('location') }}
              </small>
            </div>
            <div class="col-md-2 col-sm-6 col-xs-12 form-group">
              <label class="control-label text-purple">{{$t('marketingCampaigns.withOrdersLabel')}}</label>
              <select
                      name="with_orders"
                      class="form-control"
                      v-model="filters[9].value">
                <option selected="" value=""> - {{$t('general.all')}} - </option>
                <option value="1">{{$t('marketingCampaigns.withOrders')}}</option>
                <option value="0">{{$t('marketingCampaigns.withoutOrders')}}</option>
              </select>
            </div>
            <div :class="colsClass + ' col-sm-6 col-xs-12 form-group'">
              <!-- -->
              <label class="control-label text-purple">{{$t('marketingCampaigns.ordersAbove')}} ({{currency}})</label>
              <input type="number"  placeholder="E.g. 200" class="form-control" v-model="filters[2].value">
            </div>
            <div :class="colsClass + ' col-sm-6 col-xs-12 form-group'">
              <!-- -->
              <label class="control-label text-purple">{{$t('marketingCampaigns.ordersBelow')}} ({{currency}})</label>
              <input type="number"  placeholder="E.g. 200" class="form-control" v-model="filters[6].value">
            </div>
            <div class="col-md-2 col-sm-6 col-xs-12 form-group">
              <label class="control-label text-purple">{{$t('marketingFidelities.userLabeling')}}</label>
              <select
                      name="user_label_id"
                      placeholder=""
                      class="form-control"
                      v-model="filters[5].value"
                      v-on:change="handleFilter()">
                <option selected=""  value=""> - {{$t('general.all')}} - </option>
                <option v-for="user_label in userLabels" :key="user_label.id" :value="user_label.id">{{user_label.name}}</option>
              </select>
            </div>
            <div :class="colsClass + ' col-sm-6 col-xs-12 form-group'">
              <label class="control-label text-purple">{{$t('marketingCampaigns.ordersAboveNr')}}</label>
              <input type="number"  placeholder="E.g. 1" class="form-control" v-model="filters[7].value">
            </div>
            <div :class="colsClass + ' col-sm-6 col-xs-12 form-group'">
              <label class="control-label text-purple">{{$t('marketingCampaigns.ordersBelowNr')}}</label>
              <input type="number"  placeholder="E.g. 300" class="form-control" v-model="filters[8].value">
            </div>
            <div class="col-md-3 col-sm-6 col-xs-12 form-group">
              <label class="control-label text-purple">{{$t('marketingCampaigns.groups')}}</label>
              <v-select
                      :placeholder="$t('general.all')"
                      multiple
                      :options="customerGroups"
                      label="name"
                      v-model="filters[10].value"
                      v-on:change="handleFilter()"
                      :input="groupCustomersEvent()"
                      >
              </v-select>
            </div>
            <div class="col-md-2 col-sm-6 col-xs-12 form-group">
              <label class="control-label text-purple">{{$t('marketingCampaigns.withLoyaltyPointsLabel')}}</label>
              <select
                      name="with_loyalty_points"
                      class="form-control"
                      v-model="filters[12].value">
                <option selected="" value=""> - {{$t('marketingCampaigns.withLoyaltyPointsAll')}} - </option>
                <option value="1">{{$t('marketingCampaigns.withLoyaltyPoints')}}</option>
                <option value="0">{{$t('marketingCampaigns.withoutLoyaltyPoints')}}</option>
              </select>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12 form-group">
              <label class="control-label text-purple">{{$t('marketingCampaigns.period')}}</label>
              <el-date-picker
                v-model="filters[11].value"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                name="period"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </div>
            <div class="col-md-12 form-group">
              <label class=""></label>
              <button @click.prevent="applyFilters()" type="submit" class="btn btn-primary">
                {{ $t('reports.filter') }}
              </button>
              <button @click="resetFilters()" type="reset" class="btn btn-primary">
                {{ $t('general.reset') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <data-tables class="campaign-clients-table"
        :data="tableData"
        :table-props="{'border': false, 'stripe': false,}"
        style="width: 100%; background: #fff"
        @filtered-data="dataFiltered"
        >
      <el-table-column
        :label="$t('settingsPages.users')"
        :min-width="80">
        <template slot-scope="props">
          <template v-if="props.row.firstname != null || props.row.lastname != null">
            {{ props.row.firstname}} {{ props.row.lastname}}
          </template>
          <template v-else>
            {{ props.row.email}}
          </template>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('reports.gender')"
        :min-width="60">
        <template slot-scope="props">
          <b>{{ props.row.gender ? props.row.gender.toUpperCase() : '-' }}</b>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('reports.age')"
        :min-width="60">
        <template slot-scope="props">
          <b>{{ props.row.age ? props.row.age : '-' }}</b>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('marketingCampaigns.loyaltyPointsColumn')"
        :min-width="80">
        <template slot-scope="props">
          <b>{{ props.row.loyalty_points != null ? props.row.loyalty_points : '-' }}</b>
        </template>
      </el-table-column>
      <!-- <el-table-column
        :label="$t('reports.ordersNumber') + '#'"
        :min-width="60">
        <template slot-scope="props">
          <b>{{ props.row.counter_orders_per_customer ? props.row.counter_orders_per_customer : '-' }}</b>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('reports.totalAmount')"
        :min-width="60">
        <template slot-scope="props">
          <b>{{ props.row.sales > 0 ? formatMoneyAmount(props.row.sales, props.row.currency) : '-' }}</b>
        </template>
      </el-table-column> -->
    </data-tables>
    <el-pagination
      class="active-pagination"
      :total="paginationDef.totalRecords"
      :page-size="paginationDef.perPage"
      :current-page.sync="paginationDef.page"
      :page-count="paginationDef.totalPages"
      :pageSizes="[10,20,50]"
      layout="prev, pager, next, total"
      @current-change="handlePageChange($event)"
      @prev-click="handlePageChange($event)"
      @next-click="handlePageChange($event)">
    </el-pagination>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'

  export default {
    props: {
      userLabels: {
        type: [Object, Array],
        required: true
      },
      modelFromParent: {
        type: [Object, Array],
        required: true
      },
      daysParent: {
        type: Array,
        required: true
      },
      customerGroups: {
        type: [Object, Array]
      }
    },
    watch: {
      modelFromParent (value, oldVal) {
        this.model = value
        this.model.user_label_id = this.filters[5].value
        this.filters[1].value = value.user_filters ? value.user_filters.gender : null
        this.filters[2].value = value.user_filters ? value.user_filters.orders_above : null
        this.filters[3].value = value.user_filters ? value.user_filters.age : null
        this.filters[4].value = value.user_filters ? value.user_filters.location_id : null
        this.filters[5].value = value.user_filters ? value.user_filters.user_label_id : null
        this.filters[6].value = value.user_filters ? value.user_filters.orders_below : null
        this.filters[7].value = value.user_filters ? value.user_filters.orders_above_nr : null
        this.filters[8].value = value.user_filters ? value.user_filters.orders_below_nr : null
        this.filters[9].value = value.user_filters && (value.user_filters.with_orders === 0 || value.user_filters.with_orders === 1 || value.user_filters.with_orders === '0' || value.user_filters.with_orders === '1')
          ? String(value.user_filters.with_orders)
          : ''
        this.filters[10].value = value.user_filters ? value.user_filters.groups : null
        this.filters[11].value = value.user_filters ? value.user_filters.period : null
        this.filters[12].value = value.user_filters && (value.user_filters.with_loyalty_points === 0 || value.user_filters.with_loyalty_points === 1 || value.user_filters.with_loyalty_points === '0' || value.user_filters.with_loyalty_points === '1')
          ? String(value.user_filters.with_loyalty_points)
          : ''
        this.counter_matching_users = value.user_filters && value.user_filters.counter_matching_users ? value.user_filters.counter_matching_users : this.counter_matching_users
        this.model.counter_matching_users = this.counter_matching_users
        this.applyFilters()
      },
      daysParent (value, oldVal) {
        this.days = value
      }
    },
    computed: {
      ...mapFields(['notification_type', 'notification_mode', 'email'])
    },
    created: function () {
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        campaign_id: this.$route.params.id
      }
      this.getCustomers(data)
      let company = this.$session.get('selectedCompanyData')
      this.locations = company.locations_details.map(el => ({
        id: el.id,
        true_id: el.true_id,
        name: el.name
      }))
      if (this.locations.length > 1) {
        this.colsClass = 'col-md-2'
      }
      this.currency = this.getCurrencySymbol(company.currency_iso)
    },
    data () {
      return {
        tableData: [],
        paginationDef: {
          page: null,
          pageSize: [10, 20, 50],
          totalPages: null,
          totalRecords: null
        },
        model: this.value || this.modelFromParent,
        days: this.value || this.daysParent,
        modelValidations: {
          notification_type: {
            required: true
          },
          notification_mode: {
            required: true
          },
          email: {
            required: true,
            email: true
          }
        },
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59'
        },
        locations: [],
        colsClass: 'col-md-4',
        campaignsNotificationTypes: this.$session.get('defaultData')['campaigns_notification_types'],
        campaignsModes: this.$session.get('defaultData')['campaigns_modes'],
        filters: [
          {
            value: '',
            prop: ['firstname', 'lastname', 'sales']
          },
          {
            value: '',
            prop: ['gender']
          },
          {
            value: '',
            prop: ['sales']
            // filterFn: (row, filter) => {
            //   return row.sales >= filter.value
            // }
          },
          {
            value: '',
            prop: ['birthdate'],
            filterFn: (row, filter) => {
              var age = this.getAge(row.birthdate)
              switch (filter.value) {
                case '20':
                  if (age < 20) {
                    return row
                  }
                  break
                case '20-30':
                  if (age >= 20 && age <= 30) {
                    return row
                  }
                  break
                case '30-40':
                  if (age >= 30 && age <= 40) {
                    return row
                  }
                  break
                case '40-50':
                  if (age >= 40 && age <= 50) {
                    return row
                  }
                  break
                case '50+':
                  if (age > 50) {
                    return row
                  }
                  break
              }
              return false
            }
          },
          {
            value: '',
            prop: ['orders_locations'],
            filterFn: (row, filter) => {
              if (row.orders_locations.includes(filter.value)) {
                return true
              }
              return false
            }
          },
          {
            value: '',
            prop: ['user_label_id'],
            filterFn: (row, filter) => {
              return row.user_label_id === filter.value
            }
          },
          {
            value: '',
            prop: ['sales'],
            filterFn: (row, filter) => {
              return row.sales <= filter.value
            }
          },
          {
            value: '',
            prop: ['orders']
            // filterFn: (row, filter) => {
            //   let $contor = 0
            //   for (var i = row.orders.length - 1; i >= 0; i--) {
            //     if (row.orders[i].status !== 'DRAFT' && row.orders[i].status !== 'CANCELED') {
            //       $contor++
            //     }
            //   }
            //   return $contor >= filter.value
            // }
          },
          {
            value: '',
            prop: ['orders']
            // filterFn: (row, filter) => {
            //   let $contor = 0
            //   for (var i = row.orders.length - 1; i >= 0; i--) {
            //     if (row.orders[i].status !== 'DRAFT' && row.orders[i].status !== 'CANCELED') {
            //       $contor++
            //     }
            //   }
            //   return $contor <= filter.value
            //   // return row.orders.length <= filter.value
            // }
          },
          {
            value: '',
            prop: ['with_orders']
          },
          {
            value: '',
            prop: ['groups']
          },
          {
            value: '',
            prop: ['period']
          },
          {
            value: '',
            prop: ['with_loyalty_points']
          }
        ],
        counter_matching_users: 0,
        currency: '',
        loading: true
      }
    },
    methods: {
      groupCustomersEvent () {
        this.$emit('groupCustomers', this.filters[10].value)
      },
      appendWithLoyaltyPointsFilter (data) {
        const value = this.filters[12].value
        if (value === '0' || value === '1') {
          data.with_loyalty_points = Number(value)
        }
      },
      appendWithOrdersFilter (data) {
        const value = this.filters[9].value
        if (value === '0' || value === '1') {
          data.with_orders = Number(value)
        }
      },
      applyFilters () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        data[this.filters[1].prop[0]] = this.filters[1].value
        data[this.filters[3].prop[0]] = this.filters[3].value
        data[this.filters[4].prop[0]] = this.filters[4].value
        data[this.filters[5].prop[0]] = this.filters[5].value
        data[this.filters[10].prop[0]] = this.filters[10].value
        data['period'] = this.filters[11].value
        data['min_sales'] = this.filters[2].value
        data['max_sales'] = this.filters[6].value
        data['min_orders'] = this.filters[7].value
        data['max_orders'] = this.filters[8].value
        data['groups'] = this.sanitizeGroups(this.filters[10].value)
        this.appendWithOrdersFilter(data)
        this.appendWithLoyaltyPointsFilter(data)
        this.getCustomers(data)
      },
      resetFilters () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        data[this.filters[1].prop[0]] = this.filters[1].value = ''
        data[this.filters[3].prop[0]] = this.filters[3].value = ''
        data[this.filters[4].prop[0]] = this.filters[4].value = ''
        data[this.filters[5].prop[0]] = this.filters[5].value = ''
        data[this.filters[9].prop[0]] = this.filters[9].value = ''
        data[this.filters[10].prop[0]] = this.filters[10].value = ''
        data['min_sales'] = this.filters[2].value = ' '
        data['max_sales'] = this.filters[6].value = ' '
        data['min_orders'] = this.filters[7].value = ' '
        data['max_orders'] = this.filters[8].value = ' '
        data['groups'] = this.filters[10].value = null
        data['period'] = this.filters[11].value = null
        this.filters[12].value = ''
        this.getCustomers(data)
      },
      sanitizeGroups (groups) {
        if (!groups || !groups.length) return null
        let res = []
        Object.entries(groups).forEach(([key, value]) => {
          res.push(groups[key].id)
        })
        return res
      },
      getCustomers (data) {
        this.loading = true

        this.apiRequest('/customer', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data.data
            this.paginationDef.page = response.data.pagination.page
            this.paginationDef.perPage = response.data.pagination.perPage
            this.paginationDef.totalPages = response.data.pagination.totalPages
            this.paginationDef.totalRecords = response.data.pagination.totalRecords
          }
          this.$nextTick(function () { this.loading = false })
        })
      },
      handlePageChange (page) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          page: page
        }
        data[this.filters[1].prop[0]] = this.filters[1].value
        data[this.filters[3].prop[0]] = this.filters[3].value
        data[this.filters[4].prop[0]] = this.filters[4].value
        data[this.filters[5].prop[0]] = this.filters[5].value
        data[this.filters[10].prop[0]] = this.filters[10].value
        data['min_sales'] = this.filters[2].value
        data['max_sales'] = this.filters[6].value
        data['min_orders'] = this.filters[7].value
        data['max_orders'] = this.filters[8].value
        data['groups'] = this.filters[10].value
        this.appendWithOrdersFilter(data)
        this.appendWithLoyaltyPointsFilter(data)
        this.getCustomers(data)
      },
      dataFiltered () {
        this.counter_matching_users = this.paginationDef.totalRecords
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.model.user_filters = {
          gender: this.filters[1].value,
          orders_above: this.filters[2].value,
          age: this.filters[3].value,
          location_id: this.filters[4].value,
          user_label_id: this.filters[5].value,
          orders_below: this.filters[6].value,
          orders_above_nr: this.filters[7].value,
          orders_below_nr: this.filters[8].value,
          groups: this.filters[10].value,
          period: this.filters[11].value
        }
        if (this.filters[9].value === '0' || this.filters[9].value === '1') {
          this.model.user_filters.with_orders = Number(this.filters[9].value)
        }
        if (this.filters[12].value === '0' || this.filters[12].value === '1') {
          this.model.user_filters.with_loyalty_points = Number(this.filters[12].value)
        }
        return this.$validator.validateAll()
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/Steps/ThirdStep.vue